export default __webpack_public_path__ + "a2b7be5d98d468546d8ebc37227efc35.png";